import _get from 'lodash/get';
import { helpingMethod } from '../../../utils/HelpingMethod';

interface ManagementPeriodListItem {
  id: string | number;
  vesselId?: number;
  vesselName: string;
  manager: string;
  dateRange: string;
  status: 'Active' | 'Inactive';
}

interface ManagementPeriodApiParser {
  ManagementPeriodsListParser: (_res: unknown) => ManagementPeriodListItem[];
}

const managementPeriodApiParser: ManagementPeriodApiParser = {
  ManagementPeriodsListParser: (_res: unknown): ManagementPeriodListItem[] => {
    const arr: unknown[] = Array.isArray(_res) ? _res : _get(_res, 'data', []);

    return arr.map((itm: unknown) => {
      const from = _get(itm, 'dateFrom', '');
      const to = _get(itm, 'dateTo', '');
      const dateFrom = from ? helpingMethod.formatDate(from) : '';
      const dateTo = to ? helpingMethod.formatDate(to) : '';

      // Format date range: if only start date exists, show "startDate to Present"
      let dateRange = '';
      if (dateFrom && dateTo) {
        dateRange = `${dateFrom} to ${dateTo}`;
      } else if (dateFrom) {
        dateRange = `${dateFrom} to Present`;
      } else if (dateTo) {
        dateRange = dateTo;
      }

      return {
        id: _get(itm, 'id', 0),
        vesselId: _get(itm, 'vesselId', undefined),
        vesselName: _get(itm, 'vesselName', ''),
        manager: _get(itm, 'managerName', ''),
        dateRange,
        status: _get(itm, 'status', 'Active'),
      } as ManagementPeriodListItem;
    });
  },
};

export default managementPeriodApiParser;

// --------------- Management Period-specific types and data ---------------

export interface ManagementPeriodItem {
  id: number;
  vesselId?: number;
  vesselName: string;
  manager: string;
  dateRange: string;
  status: 'Active' | 'Inactive';
}

export interface ManagementPeriodsData {
  managementPeriods: ManagementPeriodItem[];
}
